'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type FC, useEffect, useState } from 'react';
import { FacebookShareButton, TelegramShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { cn } from '@/libs/utils';
import { Input, notification } from '@/utils/antd-imports';
import { useUserStore } from '../../store/userStoreProvider';
interface ReferralLinkInputProps {
  popover?: boolean;
  initialLink?: string | null;
  /** Текст поста для соцсетей (Twitter, Telegram, WhatsApp, Facebook quote). */
  shareTitle?: string | null;
  /** Вариант для страницы реферала (одна строка: поле + соцкнопки) */
  variant?: 'default' | 'card' | 'modal' | 'socialOnly';
  className?: string;
}
export const ReferralLinkInput: FC<ReferralLinkInputProps> = t0 => {
  const $ = _c(75);
  const {
    popover,
    initialLink,
    shareTitle: t1,
    variant: t2,
    className
  } = t0;
  const shareTitle = t1 === undefined ? null : t1;
  const variant = t2 === undefined ? "default" : t2;
  const user = useUserStore(_temp);
  const t = useTranslations("Settings.MyAccount.ReferralPage");
  const [api, contextHolder] = notification.useNotification();
  const [referralLink, setReferralLink] = useState("");
  let t3;
  if ($[0] !== initialLink || $[1] !== popover || $[2] !== user?.referralLink) {
    t3 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const link = typeof initialLink !== "undefined" ? initialLink : popover ? window.location.href : `${window.location.origin}/auth/signup?refId=${user?.referralLink || ""}`;
      setReferralLink(link || "");
    };
    $[0] = initialLink;
    $[1] = popover;
    $[2] = user?.referralLink;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = user?.referralLink;
  let t5;
  if ($[4] !== initialLink || $[5] !== popover || $[6] !== t4) {
    t5 = [initialLink, popover, t4];
    $[4] = initialLink;
    $[5] = popover;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t3, t5);
  let t6;
  if ($[8] !== api || $[9] !== referralLink || $[10] !== t) {
    t6 = async () => {
      if (!referralLink) {
        return;
      }
      ;
      try {
        await navigator.clipboard.writeText(referralLink);
        api.success({
          message: t("copied"),
          placement: "bottom"
        });
      } catch (t7) {
        const e = t7;
        console.warn(e);
      }
    };
    $[8] = api;
    $[9] = referralLink;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const copy = t6;
  const isCard = variant === "card";
  const isModal = variant === "modal";
  const isSocialOnly = variant === "socialOnly";
  let t7;
  if ($[12] !== shareTitle) {
    t7 = shareTitle?.trim() ?? "";
    $[12] = shareTitle;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const shareMessage = t7;
  const t8 = !isModal && !isSocialOnly && (isCard ? "flex-col items-center lg:flex-row" : "flex-col md:flex-row");
  const t9 = isModal && "w-full flex-col items-center gap-[20px] md:gap-[16px]";
  const t10 = isSocialOnly && "w-full flex-col items-center";
  let t11;
  if ($[14] !== className || $[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = cn("flex gap-[16px]", t8, t9, t10, className);
    $[14] = className;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== copy || $[20] !== isCard || $[21] !== isModal || $[22] !== isSocialOnly || $[23] !== referralLink) {
    t12 = !isSocialOnly && <Input value={referralLink} className={cn("!border-none !text-[#EBECFE] !focus:shadow-none", isCard ? "!h-[48px] !min-h-[48px] !min-w-0 !flex-1 !rounded-[12px] !bg-[#131424] !px-[16px] !text-[14px]" : isModal ? "!h-[48px] !w-full !min-w-0 !rounded-[12px] !bg-[#131424] !px-[16px] !text-[16px] md:!h-[56px] md:!px-[16px]" : "!h-[53px] !rounded-[16px] !bg-[#121426] !px-[24px] !text-[16px] lg:!h-[64px] lg:!text-[22px]")} readOnly={true} prefix={<svg className={cn("mr-[8px] cursor-pointer text-[#A9A4B7] hover:text-[#FFFFFF]")} onClick={copy} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Copy link</title><path d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z" stroke="currentColor" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>} />;
    $[19] = copy;
    $[20] = isCard;
    $[21] = isModal;
    $[22] = isSocialOnly;
    $[23] = referralLink;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = isCard ? "shrink-0 gap-[16px] lg:gap-[8px]" : "justify-around";
  const t14 = (isModal || isSocialOnly) && "shrink-0 md:gap-[24px]";
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = cn("flex justify-center gap-[12px]", t13, t14);
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = (isModal || isSocialOnly) && "flex size-[44px] items-center justify-center rounded-[22px] border border-[rgba(61,99,232,0.1)] bg-[rgba(61,99,232,0.1)] p-[3.667px]";
  let t17;
  if ($[28] !== t16) {
    t17 = cn("hover:opacity-75", t16);
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" fill="#3D63E8" fillOpacity="0.1" />;
    t19 = <path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" stroke="#3D63E8" strokeOpacity="0.1" strokeWidth="1.1" />;
    $[30] = t18;
    $[31] = t19;
  } else {
    t18 = $[30];
    t19 = $[31];
  }
  let t20;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <g clipPath="url(#clip0_1982_9079)"><path d="M33.5508 22.5508C33.5508 16.4756 28.6259 11.5508 22.5508 11.5508C16.4756 11.5508 11.5508 16.4756 11.5508 22.5508C11.5508 28.0411 15.5733 32.5919 20.832 33.4171V25.7305H18.0391V22.5508H20.832V20.1273C20.832 17.3705 22.4743 15.8477 24.9869 15.8477C26.19 15.8477 27.4492 16.0625 27.4492 16.0625V18.7695H26.0622C24.6958 18.7695 24.2695 19.6175 24.2695 20.4883V22.5508H27.3203L26.8326 25.7305H24.2695V33.4171C29.5283 32.5919 33.5508 28.0411 33.5508 22.5508Z" fill="#3D63E8" /></g>;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <svg width={46} height={46} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">{t18}{t19}{t20}<defs><clipPath id="clip0_1982_9079"><rect width="22" height="22" fill="white" transform="translate(11.5508 11.5508)" /></clipPath></defs></svg>;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== referralLink || $[35] !== t17) {
    t22 = <FacebookShareButton url={referralLink} className={t17}>{t21}</FacebookShareButton>;
    $[34] = referralLink;
    $[35] = t17;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = shareMessage || undefined;
  const t24 = (isModal || isSocialOnly) && "flex size-[44px] items-center justify-center rounded-[22px] border border-[rgba(61,99,232,0.1)] bg-[rgba(61,99,232,0.1)] p-[3.667px]";
  let t25;
  if ($[37] !== t24) {
    t25 = cn("hover:opacity-75", t24);
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <svg width={46} height={46} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" fill="#3D63E8" fillOpacity="0.1" /><path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" stroke="#3D63E8" strokeOpacity="0.1" strokeWidth="1.1" /><path fillRule="evenodd" clipRule="evenodd" d="M26.0023 32.1758L21.1466 25.2546L15.0678 32.1758H12.4961L20.0056 23.628L12.4961 12.9258H19.0988L23.6753 19.4489L29.4094 12.9258H31.9811L24.8201 21.0777L32.605 32.1758H26.0023ZM28.8662 30.2245H27.1348L16.1784 14.877H17.91L22.2982 21.0223L23.057 22.0887L28.8662 30.2245Z" fill="#3D63E8" /></svg>;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== referralLink || $[41] !== t23 || $[42] !== t25) {
    t27 = <TwitterShareButton url={referralLink} title={t23} className={t25}>{t26}</TwitterShareButton>;
    $[40] = referralLink;
    $[41] = t23;
    $[42] = t25;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  const t28 = shareMessage || undefined;
  const t29 = (isModal || isSocialOnly) && "flex size-[44px] items-center justify-center rounded-[22px] border border-[rgba(61,99,232,0.1)] bg-[rgba(61,99,232,0.1)] p-[3.667px]";
  let t30;
  if ($[44] !== t29) {
    t30 = cn("hover:opacity-75", t29);
    $[44] = t29;
    $[45] = t30;
  } else {
    t30 = $[45];
  }
  let t31;
  let t32;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" fill="#3D63E8" fillOpacity="0.1" />;
    t32 = <path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" stroke="#3D63E8" strokeOpacity="0.1" strokeWidth="1.1" />;
    $[46] = t31;
    $[47] = t32;
  } else {
    t31 = $[46];
    t32 = $[47];
  }
  let t33;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <g clipPath="url(#clip0_1982_9093)"><path fillRule="evenodd" clipRule="evenodd" d="M33.5508 22.5508C33.5508 28.6259 28.6259 33.5508 22.5508 33.5508C16.4756 33.5508 11.5508 28.6259 11.5508 22.5508C11.5508 16.4756 16.4756 11.5508 22.5508 11.5508C28.6259 11.5508 33.5508 16.4756 33.5508 22.5508ZM22.9451 19.6715C21.8752 20.1165 19.7369 21.0375 16.5301 22.4347C16.0094 22.6417 15.7366 22.8443 15.7118 23.0424C15.6698 23.3772 16.089 23.509 16.6599 23.6885C16.7376 23.7129 16.818 23.7382 16.9005 23.765C17.4621 23.9476 18.2177 24.1612 18.6104 24.1696C18.9667 24.1773 19.3643 24.0305 19.8033 23.729C22.7995 21.7065 24.3461 20.6843 24.4432 20.6622C24.5117 20.6467 24.6066 20.6271 24.6709 20.6843C24.7352 20.7415 24.7289 20.8497 24.7221 20.8788C24.6806 21.0558 23.035 22.5857 22.1834 23.3774C21.9179 23.6242 21.7296 23.7993 21.6911 23.8393C21.6049 23.9288 21.517 24.0136 21.4325 24.095C20.9108 24.598 20.5195 24.9752 21.4542 25.5912C21.9034 25.8872 22.2628 26.132 22.6214 26.3762C23.0131 26.6429 23.4037 26.9089 23.909 27.2401C24.0378 27.3245 24.1608 27.4122 24.2805 27.4976C24.7363 27.8225 25.1457 28.1144 25.6516 28.0679C25.9455 28.0408 26.2492 27.7644 26.4033 26.9401C26.7678 24.992 27.4841 20.771 27.6496 19.0317C27.6641 18.8793 27.6459 18.6843 27.6312 18.5986C27.6165 18.513 27.5859 18.391 27.4746 18.3007C27.3429 18.1938 27.1394 18.1713 27.0484 18.1729C26.6347 18.1801 25.9999 18.4009 22.9451 19.6715Z" fill="#3D63E8" /></g>;
    $[48] = t33;
  } else {
    t33 = $[48];
  }
  let t34;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <svg width={46} height={46} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">{t31}{t32}{t33}<defs><clipPath id="clip0_1982_9093"><rect width="22" height="22" fill="white" transform="translate(11.5508 11.5508)" /></clipPath></defs></svg>;
    $[49] = t34;
  } else {
    t34 = $[49];
  }
  let t35;
  if ($[50] !== referralLink || $[51] !== t28 || $[52] !== t30) {
    t35 = <TelegramShareButton url={referralLink} title={t28} className={t30}>{t34}</TelegramShareButton>;
    $[50] = referralLink;
    $[51] = t28;
    $[52] = t30;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  const t36 = shareMessage || undefined;
  const t37 = (isModal || isSocialOnly) && "flex size-[44px] items-center justify-center rounded-[22px] border border-[rgba(61,99,232,0.1)] bg-[rgba(61,99,232,0.1)] p-[3.667px]";
  let t38;
  if ($[54] !== t37) {
    t38 = cn("hover:opacity-75", t37);
    $[54] = t37;
    $[55] = t38;
  } else {
    t38 = $[55];
  }
  let t39;
  let t40;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" fill="#3D63E8" fillOpacity="0.1" />;
    t40 = <path d="M0.550781 22.5508C0.550781 10.4005 10.4005 0.550781 22.5508 0.550781C34.701 0.550781 44.5508 10.4005 44.5508 22.5508C44.5508 34.701 34.701 44.5508 22.5508 44.5508C10.4005 44.5508 0.550781 34.701 0.550781 22.5508Z" stroke="#3D63E8" strokeOpacity="0.1" strokeWidth="1.1" />;
    $[56] = t39;
    $[57] = t40;
  } else {
    t39 = $[56];
    t40 = $[57];
  }
  let t41;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <g clipPath="url(#clip0_1982_9099)"><path fillRule="evenodd" clipRule="evenodd" d="M33.5508 22.5508C33.5508 28.6259 28.6259 33.5508 22.5508 33.5508C20.6485 33.5508 18.859 33.0679 17.2982 32.2181L11.5508 33.5508L12.9796 27.9761C12.0701 26.3751 11.5508 24.5236 11.5508 22.5508C11.5508 16.4756 16.4756 11.5508 22.5508 11.5508C28.6259 11.5508 33.5508 16.4756 33.5508 22.5508ZM22.5508 31.9794C27.7581 31.9794 31.9794 27.758 31.9794 22.5508C31.9794 17.3435 27.7581 13.1222 22.5508 13.1222C17.3436 13.1222 13.1223 17.3435 13.1223 22.5508C13.1223 24.5613 13.7516 26.4249 14.8239 27.9552L13.9794 31.1222L17.2022 30.3165C18.722 31.3652 20.5647 31.9794 22.5508 31.9794ZM18.8244 16.9642C19.1978 16.961 19.559 16.9579 19.8009 17.4436C20.0101 17.8638 20.2674 18.5853 20.5711 19.4472L20.575 19.4584C20.6459 19.6594 20.7566 19.9733 20.6111 20.1813C20.4629 20.3932 20.1323 20.8197 19.8929 21.0959C19.8316 21.1667 19.7087 21.3286 19.8762 21.5925C19.9178 21.6581 19.9538 21.7253 19.9934 21.7993C20.1528 22.0977 20.3717 22.5071 21.2619 23.37C22.1603 24.2409 23.2874 24.7423 23.7031 24.9091C23.8161 24.9731 24.0875 25.0589 24.2696 24.8894C24.3533 24.8115 24.5111 24.61 24.6831 24.3903C24.8851 24.1322 25.1069 23.8489 25.2517 23.7109C25.2561 23.7069 25.2606 23.7028 25.2652 23.6986C25.3621 23.6097 25.5157 23.4689 25.7981 23.582C26.0453 23.6809 26.9939 24.1374 27.7103 24.4822C27.8512 24.55 27.9831 24.6135 28.099 24.6691C28.2129 24.7052 28.3782 24.8382 28.3782 25.1046C28.3782 25.7058 27.9526 27.4859 25.884 27.5227C23.8154 27.5596 21.3236 26.4777 19.4272 24.3863C17.4621 22.2192 16.879 20.7706 16.879 19.4472C16.879 17.8324 18.0084 16.9648 18.7328 16.9648C18.7634 16.9648 18.7939 16.9645 18.8244 16.9642Z" fill="#3D63E8" /></g>;
    $[58] = t41;
  } else {
    t41 = $[58];
  }
  let t42;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <svg width={46} height={46} viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">{t39}{t40}{t41}<defs><clipPath id="clip0_1982_9099"><rect width="22" height="22" fill="white" transform="translate(11.5508 11.5508)" /></clipPath></defs></svg>;
    $[59] = t42;
  } else {
    t42 = $[59];
  }
  let t43;
  if ($[60] !== referralLink || $[61] !== t36 || $[62] !== t38) {
    t43 = <WhatsappShareButton url={referralLink} title={t36} separator=":: " className={t38}>{t42}</WhatsappShareButton>;
    $[60] = referralLink;
    $[61] = t36;
    $[62] = t38;
    $[63] = t43;
  } else {
    t43 = $[63];
  }
  let t44;
  if ($[64] !== t15 || $[65] !== t22 || $[66] !== t27 || $[67] !== t35 || $[68] !== t43) {
    t44 = <div className={t15}>{t22}{t27}{t35}{t43}</div>;
    $[64] = t15;
    $[65] = t22;
    $[66] = t27;
    $[67] = t35;
    $[68] = t43;
    $[69] = t44;
  } else {
    t44 = $[69];
  }
  let t45;
  if ($[70] !== contextHolder || $[71] !== t11 || $[72] !== t12 || $[73] !== t44) {
    t45 = <div className={t11}>{contextHolder}{t12}{t44}</div>;
    $[70] = contextHolder;
    $[71] = t11;
    $[72] = t12;
    $[73] = t44;
    $[74] = t45;
  } else {
    t45 = $[74];
  }
  return t45;
};
function _temp(store) {
  return store.user;
}